<template>
  <button
    class="link text-theme flex items-center space-x-1"
    @click="$store.commit('openSiteFavourites')"
  >
    <span class="block w-5 h-5 flex-shrink-0">
      <svg class="w-full h-full" viewBox="0 0 20 18" fill="none">
        <path
          class="transition duration-300"
          d="M9.93864 16.9945C12.5943 14.3685 15.2783 11.8561 17.7882 9.1811C19.5651 7.28549 19.3212 4.28142 17.4927 2.46324C15.6371 0.620538 12.7053 0.504401 10.7013 2.19354C10.0225 2.76648 9.958 2.76648 9.29989 2.20903C7.25976 0.482464 4.24537 0.625699 2.41557 2.53808C0.589644 4.44401 0.496735 7.46228 2.33169 9.3695C4.8196 11.9542 7.39525 14.4537 9.93864 16.9945Z"
          stroke="var(--theme)"
          :fill="items.length ? `var(--theme)` : 'none'"
          stroke-miterlimit="10"
        />
      </svg>
    </span>
    <span v-if="items.length" class="font-bold">{{ items.length }}</span>
    <span class="sr-only">Favourites</span>
  </button>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SiteFavouritesMenuButton",

  computed: mapState("favourites", ["items"]),
};
</script>
